import { css, keyframes, Theme } from "@emotion/react";
import { theme } from "styles/theme";

const spin = keyframes`
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const MemberCenterPageStyle = {
  self: css`
    /*  */
  `,

  title: ({ colors, fontSize }: Theme) => css`
    color: ${colors.white};
    text-transform: uppercase;
    font-size: ${fontSize[20]};
    font-weight: 500;
    margin-top: 5px;
  `,

  balanceBlock: ({ colors }: Theme) => css`
    height: 70px;
    padding: 5px 0;
    background-color: ${theme.colors.orange[100]};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 5px;
  `,
  balance: ({ colors, fontSize }: Theme) => css`
    padding: 3px 20px;
    border-radius: 30px;
    background-color: ${colors.white};
    font-size: ${fontSize[14]};
    color: #808080;
  `,
  refreshIcon: css`
    width: 13px;
    vertical-align: middle;
    margin: -3px 0 0 6px;
    transform: rotate(0);
    path {
      fill: #808080;
    }
    &[data-loading="loading"] {
      animation: ${spin} 1s linear infinite;
    }
  `,
};
